// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Categories_establishments__2O5ni","header":"Categories_header__265Na","tableHeader":"Categories_tableHeader__xh4Ot"};